@if (messages$ | async; as messages) {
  <div>
    @for (assistiveMsg of messages[messageType.MSG_TYPE_ASSISTIVE]; track assistiveMsg) {
      <div
        class="cx-visually-hidden"
        >
        <span>{{ assistiveMsg | cxTranslate }}</span>
      </div>
    }
    @for (
      confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; track
      confMsg; let i = $index) {
      <div
        class="alert alert-success"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.SUCCESS"></cx-icon>
        </span>
        <span>{{ confMsg | cxTranslate }}</span>
        <button
          class="close"
          title="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_CONFIRMATION, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_INFO]; track infoMsg; let i = $index) {
      <div
        class="alert alert-info"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.INFO"></cx-icon>
        </span>
        <span>{{ infoMsg | cxTranslate }}</span>
        <button
          class="close"
          title="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_INFO, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (
      infoMsg of messages[messageType.MSG_TYPE_WARNING]; track
      infoMsg; let i = $index) {
      <div
        class="alert alert-warning"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.WARNING"></cx-icon>
        </span>
        <span>{{ infoMsg | cxTranslate }}</span>
        <button
          class="close"
          title="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_WARNING, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (errorMsg of messages[messageType.MSG_TYPE_ERROR]; track errorMsg; let i = $index) {
      <div
        class="alert alert-danger"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.ERROR"></cx-icon>
        </span>
        <span style="position: relative; z-index: 99; pointer-events: auto;" [innerHTML]="errorMsg | cxTranslate"></span>
        <button
          class="close"
          title="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_ERROR, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
  </div>
}
